<template>
  <div class="container">
    <div class="section_title">
      <h3 class="title">
        Co-Organizers
      </h3>
    </div>
    <div id="or-carousel" class="brand_carousel owl-carousel">
      <div class="brand_item text-center">
        <a target="_blank" href="http://www.nus.edu.sg/">
          <img src="static/img/co-organizers/co-nus.png" alt="brand">
        </a>
      </div>
      <div class="brand_item text-center">
        <a target="_blank" href="http://www.ntu.edu.sg/">
          <img src="static/img/co-organizers/co-ntu.png" alt="brand">
        </a>
      </div>
      <div class="brand_item text-center">
        <a target="_blank" href="https://www.smu.edu.sg/">
          <img src="static/img/co-organizers/co-smu.png" alt="brand">
        </a>
      </div>
      <div class="brand_item text-center">
        <a target="_blank" href="https://sutd.edu.sg/">
          <img src="static/img/co-organizers/co-sutd.png" alt="brand">
        </a>
      </div>
      <div class="brand_item text-center">
        <a target="_blank" href="https://www.a-star.edu.sg/">
          <img src="static/img/co-organizers/co-astar.png" alt="brand">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import 'owl.carousel'

export default {
  name: 'CoOrganizerSection',
  data () {
    return {
    }
  },
  mounted () {
    $('#or-carousel').owlCarousel({
      loop: true,
      autoplay: true,
      smartSpeed: 450,
      autoplayHoverPause: false,
      autoplayTimeout: 4000,
      dots: false,
      nav: false,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 2

        },
        1000: {
          items: 4

        }
      },
      items: 4
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CoOrganizerSection.vue